import { Popper, type PopperProps } from "@mui/material";
import React, { useMemo } from "react";
import styled from "@emotion/styled";

const columnMenuClass = "MuiDataGrid-menu";

const columnMenuModifiers = [
  {
    name: "offset",
    options: {
      offset: [0, 6],
    },
  },
  {
    name: "preventOverflow",
  },
];

export const DataGridPopper = (props: PopperProps) => {
  const { modifiers, placement, ...rest } = props;

  // This popper is used by two panels, the column menu panel and the preference panel
  // Check the class name to see which panel we are dealing with
  // more details on this issue: https://github.com/mui/mui-x/issues/12568
  const isColumnMenuPopper = props?.className?.includes(columnMenuClass);

  const updatedModifiers = useMemo(
    () => [
      ...(isColumnMenuPopper ? columnMenuModifiers : []),
      ...(modifiers || []),
    ],
    [modifiers, isColumnMenuPopper],
  );

  const resultantPlacement = isColumnMenuPopper ? "bottom" : placement;

  return (
    <StyledPopper
      placement={resultantPlacement}
      modifiers={updatedModifiers}
      {...rest}
    />
  );
};

const StyledPopper = styled(Popper)(({ theme }) => ({
  "& .MuiPaper-root": {
    boxShadow: `${theme.shadowV2.default}`,
    // @ts-ignore
    border: `none!important`,
    borderRadius: "6px",
    overflow: "hidden",
    ".MuiFormControlLabel-root": {
      marginLeft: "0px!important",
      gap: "5px",
    },
  },
}));
